import type { ListLeadsResult, Router } from '@aikoa/api'
import type { inferRouterOutputs } from '@trpc/server'

type AppRouterOutputs = inferRouterOutputs<Router>

export type Lead = ListLeadsResult['items'][number]

export type LeadTeaser = AppRouterOutputs['leads']['teaser'][number]

export type LeadDetail = NonNullable<AppRouterOutputs['leads']['get']>

export type AssetLeadMatch = NonNullable<AppRouterOutputs['leads']['getAssetLeadMatch']>

export type LeadInterest = LeadDetail['interests'][number]

export type LeadState = 'own' | 'foreign-available' | 'foreign-purchased'

export function getLeadState(lead: LeadDetail): LeadState {
  if (lead.is_own) {
    return 'own'
  }

  if (lead.is_purchased) {
    return 'foreign-purchased'
  }

  return 'foreign-available'
}

export type LeadDetailTabs = 'interest' | 'matches' | 'feedback'
